import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import ModalCancelUploaderImage from "../modals/ModalCancelUploaderImage";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import useDownloader from "react-use-downloader";
import { DocumentUrl } from "../../models/cartable.model";

export default function LoadDocumentComponent(props: any) {
  let fileType;
  let documentTypeTitle;
  if (props.data.fileType == undefined) {
    let type = props.data?.fileData.type.split("/");
    fileType = type[1];
  } else {
    fileType = props.data.fileType;
  }
  if (props.data.documentTypeTitle == undefined) {
    documentTypeTitle = props.data.fileName;
  } else {
    documentTypeTitle = props.data.documentTypeTitle;
  }

  const { download } = useDownloader();
  let typeFiles: any;
  let type;
  if (
    fileType.toLowerCase() == "image" ||
    fileType == "png" ||
    props.data?.fileData.type.toLowerCase().includes("image")
  ) {
    typeFiles = (
      <img
        src={props.data.fileUrl}
        className="uploadImageImg"
        style={{ padding: "1vh", width: "inherit !important" }}
        alt=""
      />
    );
    type = "jpg";
  } else if (fileType == "PDF" || fileType == "pdf") {
    typeFiles = (
      <PictureAsPdfOutlinedIcon
        className="uploadImageIcon jusfityImage"
        style={{ width: "1em", height: "1em" }}
      />
    );
    type = "pdf";
  } else if (
    fileType == "ZIP" ||
    fileType == "RAR" ||
    fileType == "rar" ||
    fileType == "zip"
  ) {
    typeFiles = (
      <FolderZipOutlinedIcon className="uploadImageIcon jusfityImage" />
    );
    type = "RAR";
  } else {
    typeFiles = (
      <InsertDriveFileOutlinedIcon className="uploadImageIcon jusfityImage" />
    );
    type = "jpg";
  }

  if (fileType == null || fileType == undefined) {
    typeFiles = null;
  }
  const fileUrl = props.data.fileUrl;
  const queryClient = useQueryClient();
  const filename = `${type}`;
  const handleDownloda = () => {
    download(fileUrl, filename);
    window.open(fileUrl);
  };
  // const deleteDocument = useMutation(
  //     DeleteAttachmentNotice,
  //     {
  //         onSuccess: (
  //             result: ApiResultModel<boolean>) => {
  //             if (result.isSuccess == true) {
  //                 let noticeAttachment = props.attachment?.filter((item: any) => item.fileId != props.serviceRequestObj.fileId);
  //                 let getFileUrl = noticeAttachment?.map((item: any) => item.fileUrl);
  //                 props.setChildValue(getFileUrl);
  //             }
  //         },
  //         onError: () => { },
  //     });

  const deleteDocument = useMutation(props.serviceName, {
    onSuccess: async (data: boolean) => {
      if (data) {
        if (props.cacheName != undefined) {
          let supplierAttachments = queryClient.getQueryData<DocumentUrl[]>(
            props.cacheName
          );
          supplierAttachments?.map((item: any) => {
            if (item.fileId === props.data.fileId) {
              item.fileUrl = undefined;
              return;
            }
          });
          queryClient.setQueryData(props.cacheName, supplierAttachments);
          props.setChildValue(queryClient.getQueryData(props.cacheName));
        } else if (props.attachments != undefined) {
          let attachmentsTemprory = props.attachments?.filter(
            (x: { fileId: any }) => x.fileId != props.data.fileId
          );
          props.setChildValue(attachmentsTemprory);
        } else {
          props.setChildValue(undefined);
        }
      }
    },
    onError: (err) => {},
  });

  const deleteImage = () => {
    if (props.serviceRequestObj != undefined) {
      deleteDocument.mutate(props.serviceRequestObj);
    } else if (props.multiItem != undefined && props.multiItem) {
      let supplierAttachments = props.attachments?.filter(
        (item: any) => item.fileUrl != props.data.fileUrl
      );

      props.setChildValue(supplierAttachments);
    } else {
      props.setChildValue(undefined);
    }
  };

  return (
    <div className="UploadImageCmp">
      {typeFiles ? (
        <span
          onClick={handleDownloda}
          className="uploadImage verticalCenter"
          style={{ width: "inherit !important", height: "80%" }}
        >
          {typeFiles}
        </span>
      ) : (
        <a href={`${props.data.fileUrl!}/true`} target="blank">
          <img
            style={{ padding: "1vh", width: "inherit !important" }}
            src={props.data.fileUrl ? `${props.data.fileUrl}/true` : ""}
            className="uploadImage"
            alt=""
          />
        </a>
      )}
      <Grid
        className="row rowUploadImage"
        container
        xs={12}
        alignItems={"center"}
      >
        <Grid item xs={10}>
          <div
            style={{ color: "#fff", marginRight: "10px", overflow: "hidden" }}
          >
            <p className="paraghramImage infoText">{documentTypeTitle}</p>
          </div>
        </Grid>
        <Grid item xs={2} style={{ paddingBottom: "10px" }}>
          <ModalCancelUploaderImage
            title={""}
            bgColor={"kamanColor"}
            setValue={deleteImage}
          />
        </Grid>
      </Grid>
    </div>
  );
}
